import React from 'react';
import ScrollAnimation from "react-animate-on-scroll";


const SplitOne = () => {
    return (
        <div className="rn-splite-style">
            <div className="split-wrapper">
                <div className="row no-gutters radius-10 align-items-center">
                    <div className="col-lg-12 col-xl-6 col-12">
                        <div className="thumbnail image-left-content">
                            <img src="../images/split/split-01.jpg" alt="split Images"/>
                        </div>
                    </div>
                    <div className="col-lg-12 col-xl-6 col-12">
                        <div className="split-inner">
                            <ScrollAnimation
                                animateIn="fadeInUp"
                                animateOut="fadeInOut"
                                animateOnce={true}>
                                <h4 className="title">Quality Web Designs</h4>
                            </ScrollAnimation>
                            <ScrollAnimation
                                animateIn="fadeInUp"
                                animateOut="fadeInOut"
                                animateOnce={true}>
                                <p className="description">
                                    We are a top web design firm in Kenya, assisting companies of all kinds in getting
                                    the most out of their investments. To design and construct great websites, we
                                    combine our creativity and technological expertise.
                                </p>
                                <p>
                                    We can assist you with a variety
                                    of web marketing methods based on our extensive knowledge. Our team of accommodating
                                    web designers will work with you to guarantee your final product is exactly what you
                                    envisioned.
                                </p>
                            </ScrollAnimation>

                            <ScrollAnimation
                                animateIn="fadeInUp"
                                animateOut="fadeInOut"
                                animateOnce={true}>
                                <div className="view-more-button mt--35">
                                    <a className="btn-default" href="/contact">Contact Us</a>
                                </div>
                            </ScrollAnimation>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default SplitOne
